// extracted by mini-css-extract-plugin
export default {"root":"BlockUserButton_root__tbvbO","button":"BlockUserButton_button__8lPKz","unblockButton":"BlockUserButton_unblockButton__nlyWW","error":"BlockUserButton_error__ty2US"};